import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanToString' })
export class BooleanToStringPipe implements PipeTransform {
  transform(value: boolean | null): string {
    if (value === null) {
      return 'n/a';
    } else {
      return value ? 'Yes' : 'No';
    }
  }
}
